import { useState } from 'react';

/**
 * Hook para mostrar un ConfirmDialog con una API basada en Promise.
 *
 * Uso:
 *   const { confirm, pedirConfirm } = useConfirm();
 *
 *   const ok = await pedirConfirm({ titulo: '...', mensaje: '...', peligro: true });
 *   if (!ok) return;
 *
 * Renderizar al final del JSX:
 *   <ConfirmDialog {...confirm} abierto={confirm !== null} />
 */
export function useConfirm() {
  const [confirm, setConfirm] = useState(null);

  const pedirConfirm = (opts) =>
    new Promise(resolve => {
      setConfirm({
        ...opts,
        onConfirm: () => { setConfirm(null); resolve(true); },
        onCancel:  () => { setConfirm(null); resolve(false); },
      });
    });

  return { confirm, pedirConfirm };
}
